@if (rowActivities) {
  @for (
    activity of rowActivities;
    track trackByActivities(i, activity);
    let i = $index
  ) {
    @if (
      {
        activityStartTime: activity | ganttActivityStartTime,
        activityEndTime: activity | ganttActivityEndTime,
        isActivityStartLocationMismatch:
          shift.activities | ganttIsActivityStartLocationMismatch: activity.id,
        isActivityEndLocationMismatch:
          shift.activities | ganttIsActivityEndLocationMismatch: activity.id,
        isMoveMode: dragAndDropModeService.isMoveMode$ | async,
        isReported: activity.activityReports?.length,
        selectedShifts: shiftMultiSelectHelperService.selectedShifts$ | async,
      };
      as data
    ) {
      <wilson-timeline-auto-size-activity-card
        [activity]="activity"
        [userId]="userId"
        [containerWidthPx]="shiftWidthPx"
        [accurateActivityStartDateTime]="data.activityStartTime.date"
        [activityStartTimeDifference]="data.activityStartTime.timeDifference"
        [accurateActivityEndDateTime]="data.activityEndTime.date"
        [activityEndTimeDifference]="data.activityEndTime.timeDifference"
        [activityStartTimeType]="data.activityStartTime.type"
        [activityEndTimeType]="data.activityEndTime.type"
        [accurateContainerStartDateTime]="accurateShiftStartDateTime"
        [accurateContainerEndDateTime]="accurateShiftEndDateTime"
        [shiftPublicationStatus]="shift.publicationStatus"
        [shiftActivities]="shift.activities"
        [accurateContainerDurationMs]="accurateShiftDurationMs"
        [filteredActivityId]="filteredActivityId"
        [isActivityStartLocationMismatch]="data.isActivityStartLocationMismatch"
        [isActivityEndLocationMismatch]="data.isActivityEndLocationMismatch"
        [isCursorGrab]="isCursorGrab"
        [userId]="shift.userId"
        [isDraggable]="
          isActivityDraggable &&
          !(
            data.isReported ||
            (data.isMoveMode && shift.activities.length === 1)
          )
        "
        (click)="
          handleSelectedActivity(
            $event,
            activity.id,
            data.activityStartTime.date,
            data.activityEndTime.date,
            data.selectedShifts ?? []
          )
        "
      ></wilson-timeline-auto-size-activity-card>
    }
  }
}
